import styles from './Input.module.css';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { GlobalService } from '../../../hexagonal-architecture-frontend-base/src/domain/services/Global.service';
import InputOld from '../InputOld';
import { FC } from 'react';

const cx = classNames.bind(styles);

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  id: string;
  label: string;
  placeholder?: string;
  enableShowPassword?: boolean;
  value: string;
  onChange?: (value: any) => void;
  errorMessage?: string | null;
}

export const Input: FC<InputProps> = ({
  id,
  label,
  placeholder = '',
  type,
  enableShowPassword,
  value,
  onChange,
  errorMessage = null,
  disabled,
  className,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('login-input--container')}>
      {label && (
        <label htmlFor={id} className={cx('login-input--label')}>
          {GlobalService.uppercaseFirstLetter(t(label), false)}
        </label>
      )}

      <InputOld
        {...rest}
        value={value}
        type={type}
        enableShowPassword={enableShowPassword}
        id={id}
        name={id}
        placeholder={GlobalService.uppercaseFirstLetter(t(placeholder))}
        customClass={cx('login-input--input', className, { disabled })}
        onChange={e => onChange?.(e)}
        disabled={disabled}
      />

      {errorMessage && (
        <p className={cx('error-message', 'my-2', 'mx-4')}>
          {GlobalService.uppercaseFirstLetter(t(errorMessage))}
        </p>
      )}
    </div>
  );
};
